import { Dropdown } from "primereact/dropdown";
import { translatedMessage } from "../service/LanguageService";
import { MultiSelect } from 'primereact/multiselect';

const RecruitmentDataTableUtils = {

  statusBodyTemplate(_status) {
    return (
      <div className={`inline-block status status-${_status.toLowerCase()}`}>{translatedMessage("RecruitmentStatus." + _status)}</div>
    )
  },

  statusFilterTemplate(options, statuses) {
    return <MultiSelect
      value={options.value}
      options={statuses}
      onChange={(e) => options.filterApplyCallback(e.value)}
      placeholder={translatedMessage('generic.status')}
      className="p-column-filter"
      maxSelectedLabels={1}
      showSelectAll={false}
      selectedItemsLabel={"{0} " + translatedMessage("multiselect.selectedItems")}
      itemTemplate={(e) => this.statusBodyTemplate(e.value)}
    />
  },

  campaignStatusBodyTemplate(_status) {
    return (
      <div className={`inline-block status status-${_status.toLowerCase()}`}>{translatedMessage("RecruitmentCampaignStatus." + _status)}</div>
    )
  },

  campaignstatusFilterTemplate(options, statuses) {
    return <MultiSelect
      value={options.value}
      options={statuses}
      onChange={(e) => options.filterApplyCallback(e.value)}
      placeholder={translatedMessage('generic.status')}
      className="p-column-filter"
      maxSelectedLabels={1}
      showSelectAll={false}
      selectedItemsLabel={"{0} " + translatedMessage("multiselect.selectedItems")}
      itemTemplate={(e) => this.campaignStatusBodyTemplate(e.value)}
    />
  },

  planStatusBodyTemplate(_status) {
    return (
      <div className={`inline-block status status-recruitmenPlan-${_status.toLowerCase()}`}>{translatedMessage("RecruitmentPlanStatus." + _status)}</div>
    )
  },

  planStatusFilterTemplate(options, statuses) {
    return <MultiSelect
      value={options.value}
      options={statuses}
      onChange={(e) => options.filterApplyCallback(e.value)}
      placeholder={translatedMessage('generic.status')}
      className="p-column-filter"
      maxSelectedLabels={1}
      showSelectAll={false}
      selectedItemsLabel={"{0} " + translatedMessage("multiselect.selectedItems")}
      itemTemplate={(e) => this.planStatusBodyTemplate(e.value)}
    />
  },

  planCampaignsFilterTemplate(options, campaigns) {
    return <Dropdown
      value={options.value}
      options={campaigns}
      onChange={(e) => options.filterApplyCallback(e.value)}
      className="p-column-filter"
      itemTemplate={(e) => e.value}
    />
  },

  vacancyTemplate(value) {
    return (
      <span>
        <div style={{ display: 'block' }}>{value?.vacancyForecasted ? translatedMessage("generic.yes") : translatedMessage("generic.no")}</div>
        {value?.vacancyForecasted
          ? <div style={{ display: 'block' }}>{translatedMessage("semester." + value?.vacancySemester) + " - " + value.vacancyYear}</div>
          : <></>
        }
      </span>
    )
  },

};

export default RecruitmentDataTableUtils;